import { OpaqueToken } from '@angular/core';
export var FirebaseConfig = new OpaqueToken('FirebaseUrl');
export var FirebaseApp = new OpaqueToken('FirebaseApp');
export var FirebaseAuthConfig = new OpaqueToken('FirebaseAuthConfig');
export var FirebaseUserConfig = new OpaqueToken('FirebaseUserConfig');
export var FirebaseAppName = new OpaqueToken('FirebaseAppName');
export var WindowLocation = new OpaqueToken('WindowLocation');
export var FirebaseRef = FirebaseApp;
export var FirebaseUrl = FirebaseConfig;
//# sourceMappingURL=tokens.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/angularfire2/tokens.js
// module id = ../../../../angularfire2/tokens.js
// module chunks = 16